// ✅ CONFIGURACIÓN DE GRUPOS DE MENÚ - REUTILIZANDO IMPORTS EXACTOS DEL ARCHIVO ORIGINAL
// Este archivo mapea los elementos del menú actual a la nueva estructura agrupada

import React from 'react';

// Iconos de los elementos del menú
// eslint-disable-next-line no-unused-vars
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import PeopleAltOutlinedIcon from "@material-ui/icons/PeopleAltOutlined";
import VpnKeyIcon from "@material-ui/icons/VpnKey";
import GroupWorkIcon from "@material-ui/icons/GroupWork";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import AccountTreeOutlinedIcon from "@material-ui/icons/AccountTreeOutlined";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import CodeRoundedIcon from "@material-ui/icons/CodeRounded";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import PeopleIcon from "@material-ui/icons/People";
import ListIcon from "@material-ui/icons/ListAlt";
import WatchLaterIcon from "@material-ui/icons/WatchLater";
import AnnouncementIcon from "@material-ui/icons/Announcement";
import ForumIcon from "@material-ui/icons/Forum";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
// import RotateRight from "@material-ui/icons/RotateRight"; // ✅ No utilizado por ahora
import LoyaltyRoundedIcon from '@material-ui/icons/LoyaltyRounded';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import { AllInclusive, AttachFile, DeviceHubOutlined, Schedule, Speed as SpeedIcon, Assessment as AssessmentIcon, AccountTree, Tune, Description as DescriptionIcon } from '@material-ui/icons';
import SecurityIcon from "@material-ui/icons/Security";
// eslint-disable-next-line no-unused-vars

// ✅ FUNCIÓN UNIFICADA PARA RENDERIZAR ICONOS CON ESTILO CONSISTENTE
const renderIconUnified = (IconComponent) => {
  return (
    <IconComponent 
      style={{ 
        fontSize: '20px',
        color: 'inherit',
        transition: 'all 0.2s ease-in-out',
      }}
    />
  );
};

// ✅ FUNCIONES DE ICONOS (MANTENIDAS PARA COMPATIBILIDAD, PERO USAN ESTILO UNIFICADO)
const renderIconWhatsApp = renderIconUnified;
const renderIconDashboard = renderIconUnified;
const renderIconMensajes = renderIconUnified;
const renderIconConfiguracion = renderIconUnified;
const renderIconUtilidades = renderIconUnified;
const renderIconGruposWA = renderIconUnified;

// ✅ CONFIGURACIÓN DE GRUPOS DE MENÚ
export const menuGroupsConfig = {
  whatsapp: {
    id: 'whatsapp',
    titleKey: 'mainDrawer.groups.whatsapp',
    icon: '💬',
    renderIcon: renderIconWhatsApp,
    expanded: true, // ✅ Expandido por defecto
    items: [
      {
        name: 'Tickets',
        route: '/tickets',
        icon: WhatsAppIcon,
        translationKey: 'mainDrawer.listItems.tickets',
        permission: 'tickets:ver',
        fallback: 'service',
      },
      {
        name: 'Respuestas rápida',
        route: '/quick-messages',
        icon: FlashOnIcon,
        translationKey: 'mainDrawer.listItems.quickMessages',
        permission: 'quickmessages:ver',
        fallback: 'service',
      },
      {
        name: 'Kanban',
        route: '/kanban',
        icon: LoyaltyRoundedIcon,
        translationKey: 'mainDrawer.listItems.kanban',
        permission: 'kanban:ver',
        fallback: 'service',
        conditional: 'showKanban'
      },
      {
        name: 'Contactos',
        route: '/contacts',
        icon: ContactPhoneOutlinedIcon,
        translationKey: 'mainDrawer.listItems.contacts',
        permission: 'contacts:ver',
        fallback: 'service',
      },
      {
        name: 'Agenda',
        route: '/schedules',
        icon: Schedule,
        translationKey: 'mainDrawer.listItems.schedules',
        permission: 'agenda:ver',
        fallback: 'service',
        conditional: 'showSchedules'
      },
      {
        name: 'Etiquetas',
        route: '/tags',
        icon: LocalOfferIcon,
        translationKey: 'mainDrawer.listItems.tags',
        permission: 'tags:ver',
        fallback: 'service',
      },
      {
        name: 'Lista de archivos',
        route: '/files',
        icon: AttachFile,
        translationKey: 'mainDrawer.listItems.files',
        permission: 'files:ver',
        fallback: 'service',
      },
      {
        // Visible para TODOS los perfiles a propósito (doc 0380 H4): un agente
        // debe poder saber a qué equipo pertenece y quién lo supervisa.
        name: 'Mi equipo',
        route: '/my-team',
        icon: GroupWorkIcon,
        translationKey: 'mainDrawer.listItems.myTeam',
        permission: null,
        fallback: 'service',
      },
      {
        name: 'Ayuda',
        route: '/helps',
        icon: HelpOutlineIcon,
        translationKey: 'mainDrawer.listItems.helps',
        permission: null,
        fallback: 'service',
      },
      {
        name: 'API',
        route: '/messages-api',
        icon: CodeRoundedIcon,
        translationKey: 'mainDrawer.listItems.messagesAPI',
        permission: 'api:ver',
        fallback: 'admin',
        conditional: 'showExternalApi'
      }
    ]
  },
  
  dashboard: {
    id: 'dashboard',
    titleKey: 'mainDrawer.groups.dashboard',
    icon: '📊',
    renderIcon: renderIconDashboard,
    expanded: false,
    route: null, // ✅ Sin ruta directa - solo submenús
    items: [
      {
        name: 'Métricas',
        route: '/',
        icon: DashboardOutlinedIcon,
        translationKey: 'mainDrawer.listItems.metrics',
        permission: 'reports:ver',
        fallback: 'admin',
      },
      {
        name: 'Conexiones',
        route: '/dashboard/connections',
        icon: SyncAltIcon,
        translationKey: 'mainDrawer.listItems.connections',
        permission: 'reports:ver',
        fallback: 'admin',
      },
      // ✅ ELIMINADO: "Rendimiento CPU" - Ya no se necesita, reemplazado por "Rendimiento VPS"
      {
        name: 'WhatsApp',
        route: '/dashboard/whatsapp',
        icon: WhatsAppIcon,
        translationKey: 'mainDrawer.listItems.dashboardWhatsApp',
        permission: 'reports:ver',
        fallback: 'admin',
        conditional: 'user.super' // Solo super admin
      },
      {
        name: 'Rendimiento VPS',
        route: '/dashboard/vps-performance',
        icon: SpeedIcon,
        translationKey: 'mainDrawer.listItems.vpsPerformance',
        permission: 'settings:administrar',
        fallback: 'admin',
        conditional: 'user.super' // Solo super admin
      }
    ]
  },
  
  gruposWA: {
    id: 'gruposWA',
    titleKey: 'mainDrawer.groups.gruposWA',
    icon: '👥',
    renderIcon: renderIconGruposWA,
    expanded: false,
    items: [
      {
        name: 'Lista de Grupos',
        route: '/groups-wa',
        icon: PeopleIcon,
        translationKey: 'mainDrawer.listItems.groupsWA',
        permission: 'groups:ver',
        fallback: 'admin',
      },
      {
        name: 'Campañas de Grupos',
        route: '/group-campaigns',
        icon: ListIcon,
        translationKey: 'mainDrawer.listItems.groupCampaigns',
        permission: 'campaigns:ver',
        fallback: 'admin',
      }
    ]
  },
  
  mensajes: {
    id: 'mensajes',
    titleKey: 'mainDrawer.groups.mensajes',
    icon: '📢',
    renderIcon: renderIconMensajes,
    expanded: false,
    items: [
      {
        name: 'Envío de mensajes',
        route: '/campaigns',
        icon: ListIcon,
        translationKey: 'mainDrawer.listItems.campaignsDispatch',
        permission: 'campaigns:ver',
        fallback: 'admin',
        conditional: 'showCampaigns'
      },
      {
        name: 'Campañas Meta',
        route: '/meta-campaigns',
        icon: DescriptionIcon,
        translationKey: 'mainDrawer.listItems.metaCampaigns',
        permission: 'campaigns:ver',
        fallback: 'admin',
        conditional: 'showCampaigns'
      },
      {
        name: 'Plantillas Meta',
        route: '/plantillas-meta',
        icon: DescriptionIcon,
        translationKey: 'mainDrawer.listItems.wabaTemplates',
        permission: 'campaigns:ver',
        fallback: 'admin',
        conditional: 'showCampaigns'
      },
      {
        name: 'Individual',
        route: '/scheduled-messages',
        icon: WatchLaterIcon,
        translationKey: 'mainDrawer.listItems.scheduledMessages',
        permission: 'schedules:ver',
        fallback: 'admin',
        conditional: 'showCampaigns'
      },
      {
        name: 'Lista de contactos',
        route: '/contact-lists',
        icon: PeopleIcon,
        translationKey: 'mainDrawer.listItems.contactLists',
        permission: 'campaigns:ver',
        fallback: 'admin',
        conditional: 'showCampaigns'
      },
      {
        name: 'Informe de Envío',
        route: '/campaign-shipping-reports',
        icon: AssessmentIcon,
        translationKey: 'mainDrawer.listItems.campaignShippingReports',
        permission: 'campaigns:ver',
        fallback: 'admin',
        conditional: 'showCampaigns'
      },
      {
        name: 'Plantillas de Difusión',
        route: '/broadcast-templates',
        icon: DescriptionIcon,
        translationKey: 'mainDrawer.listItems.broadcastTemplates',
        permission: 'campaigns:ver',
        fallback: 'admin',
        conditional: 'showCampaigns'
      },
      // ❌ DEPRECADO: Configuración de intervalos ahora está integrada en el formulario de campañas
      // {
      //   name: 'Tiempos de envío',
      //   route: '/campaigns-config',
      //   icon: ListIcon,
      //   translationKey: 'hardcodedElements.configuracoes',
      //   permission: 'drawer-admin-items:view',
      //   conditional: 'showCampaigns'
      // }
    ]
  },
  
  configuracion: {
    id: 'configuracion',
    titleKey: 'mainDrawer.groups.configuracion',
    icon: '⚙️',
    renderIcon: renderIconConfiguracion,
    expanded: false,
    items: [
      {
        name: 'Conexiones',
        route: '/connections',
        icon: SyncAltIcon,
        translationKey: 'mainDrawer.listItems.connections',
        permission: 'connections:ver',
        fallback: 'admin',
      },
      {
        name: 'Departamentos',
        route: '/queues',
        icon: AccountTreeOutlinedIcon,
        translationKey: 'mainDrawer.listItems.queues',
        permission: 'queues:ver',
        fallback: 'admin',
      },
      {
        name: 'Agentes IA',
        route: '/prompts',
        icon: AllInclusive,
        translationKey: 'mainDrawer.listItems.prompts',
        permission: 'prompts:ver',
        fallback: 'admin',
        conditional: 'showOpenAi'
      },
      {
        name: 'Configuraciones',
        route: '/settings',
        icon: SettingsOutlinedIcon,
        translationKey: 'mainDrawer.listItems.settings',
        permission: 'settings:ver',
        fallback: 'admin',
      }
    ]
  },
  
  /**
   * ADMINISTRACIÓN — quién es quién y qué puede hacer.
   *
   * WHY grupo propio y no dentro de Configuración: allí convivían con
   * conexiones, plantillas y ajustes del producto, y no se encontraban. Estas
   * tres pantallas responden a una pregunta distinta —gobierno de personas, no
   * configuración del canal— y juntas se exploran solas.
   *
   * Acceso: `drawer-admin-items:view`, igual que Configuración. Lo tienen el
   * superadministrador y el administrador de empresa; un agente no ve el grupo.
   */
  administracion: {
    id: 'administracion',
    titleKey: 'mainDrawer.groups.administracion',
    icon: '🛡️',
    renderIcon: renderIconConfiguracion,
    expanded: false,
    items: [
      {
        name: 'Rol de usuario',
        route: '/users',
        icon: PeopleAltOutlinedIcon,
        translationKey: 'mainDrawer.listItems.userRoles',
        permission: 'users:ver',
        fallback: 'admin',
      },
      {
        name: 'Roles y permisos',
        route: '/roles',
        icon: VpnKeyIcon,
        translationKey: 'mainDrawer.listItems.rolesPermissions',
        permission: 'roles:ver',
        fallback: 'admin',
      },
      {
        name: 'Subagrupaciones',
        route: '/user-groups',
        icon: GroupWorkIcon,
        translationKey: 'mainDrawer.listItems.userGroups',
        permission: 'user-groups:ver',
        fallback: 'admin',
        // Solo para empresas que trabajan por equipos (doc 0380 D7). Sin esto,
        // el cliente de un solo administrador ve una página que no necesita.
        conditional: 'teamsEnabled'
      },
      {
        // Registro de seguridad (doc 0431, M-09): quién entró, cambios de permisos, alertas.
        name: 'Seguridad',
        route: '/security-audit',
        icon: SecurityIcon,
        translationKey: 'mainDrawer.listItems.securityAudit',
        permission: 'settings:administrar',
        fallback: 'admin',
      }
    ]
  },

  flowbuilder: {
    id: 'flowbuilder',
    titleKey: 'mainDrawer.groups.flowbuilder',
    icon: '🔄',
    renderIcon: renderIconUtilidades,
    expanded: false,
    items: [
      {
        name: 'Lista de Flujos',
        route: '/flowbuilders',
        icon: AccountTree,
        translationKey: 'mainDrawer.listItems.flowbuilders',
        permission: 'flowbuilder:ver',
        fallback: 'admin',
      },
      {
        name: 'Campañas de Flujo',
        route: '/flowcampaigns',
        icon: ListIcon,
        translationKey: 'mainDrawer.listItems.flowcampaigns',
        permission: 'flowbuilder:ver',
        fallback: 'admin',
      }
    ]
  },
  
  utilidades: {
    id: 'utilidades',
    titleKey: 'mainDrawer.groups.utilidades',
    icon: '🔧',
    renderIcon: renderIconUtilidades,
    expanded: false,
    items: [
      {
        name: 'Integraciones',
        route: '/queue-integration',
        icon: DeviceHubOutlined,
        translationKey: 'mainDrawer.listItems.queueIntegration',
        permission: 'settings:administrar',
        fallback: 'admin',
        conditional: 'showIntegrations'
      },
      {
        name: 'Chat local',
        route: '/chats',
        icon: ForumIcon,
        translationKey: 'mainDrawer.listItems.localChat',
        permission: 'chats:ver',
        fallback: 'service',
        conditional: 'showInternalChat'
      },
      {
        name: 'Anuncios',
        route: '/announcements',
        icon: AnnouncementIcon,
        translationKey: 'mainDrawer.listItems.annoucements',
        permission: 'announcements:ver',
        fallback: 'admin',
        conditional: 'user.superOrCompanyAdmin'
      }
    ]
  }
};

// ✅ FUNCIONES HELPER
export const getMenuGroupConfig = (groupId) => {
  return menuGroupsConfig[groupId] || null;
};

export const getAllMenuGroups = () => {
  return Object.values(menuGroupsConfig);
};

export const getMenuGroupItems = (groupId) => {
  const group = getMenuGroupConfig(groupId);
  return group ? group.items : [];
};